import { InjectionKey } from 'vue';
import { useDashboardProvider } from './dashboard.provider';

export const IKDashboard = Symbol('IKDashboard') as InjectionKey<ReturnType<typeof useDashboardProvider>>;
